export const MARK_FOR_DELETE_KEY = "Mark for Delete";
export const REASON_FOR_DELETE_KEY = "Reason for Delete";
export const MAX_CHARS_REASON_FOR_DELETE = 400;
export const REASON_FOR_DELETE_PROMPT = 'Please enter your reason for delete (no more than ' + MAX_CHARS_REASON_FOR_DELETE + ' characters:';